import Image from "next/image";

import { Button, ButtonProps, css, styled } from "@mui/material";

import { getColor } from "@hooks/useColors";

export const MainContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    ${theme.breakpoints.up("mobile")} {
      width: 200px;
      gap: 0.5rem;
      padding: 12px 12px 16px 12px;
    }

    ${theme.breakpoints.up("mobile")} {
      width: 202px;
    }

    ${theme.breakpoints.up("desktop")} {
      width: 280px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: 380px;
      gap: 0.75rem;
      padding: 16px 16px 24px 16px;
    }

    border: 1px solid
      ${getColor(c => c.foundations.alpha.neutral["alpha-10"], theme)};
    border-radius: 8px;
  `,
);

export const ImageContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    position: relative;
    overflow: hidden;

    padding: 4px;

    border: 1px solid
      ${getColor(c => c.foundations.alpha.neutral["alpha-16"], theme)};
    border-radius: 4px;

    &:hover .fire-hover {
      left: 0;
    }
  `,
);

export const WorkerImage = styled(Image)(
  ({ theme }) => css`
    border: 1px solid
      ${getColor(c => c.foundations.alpha.neutral["alpha-24"], theme)};
    border-radius: 2px;
  `,
);

export const WorkerInfoContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;

    background-color: ${getColor(c => c.foundations.blue[500], theme)};
    border-radius: 2px;

    transition: left 420ms ease;

    margin: 4px;
    top: 0;
    left: 100%;
    width: calc(100% - 8px);
    height: calc(100% - 8px);
  `,
);

export const WorkerInfoTextContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    ${theme.breakpoints.up("mobile")} {
      gap: 0;
      padding: 12px 8px 0 8px;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 0.25rem;
      padding: 12px 12px 0 12px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      gap: 0.5rem;
      padding: 24px 16px 0 16px;
    }

    span {
      color: ${getColor(c => c.tokens.static["static-white"], theme)};
    }
  `,
);

export const LinkedInBtn = styled(Button)<ButtonProps & { target: string }>(
  ({ theme }) => css`
    padding: 0;

    ${theme.breakpoints.up("mobile")} {
      margin: 0 8px 8px 0;

      border-radius: 6px;
      height: 24px;
      min-width: 24px;
      width: 24px;
    }

    ${theme.breakpoints.up("desktop")} {
      margin: 0 12px 12px 0;

      border-radius: 10px;
      height: 40px;
      min-width: 40px;
      width: 40px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      margin: 0 24px 24px 0;
    }

    background: ${getColor(c => c.tokens.static["static-white"], theme)};
    border: 1px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)};

    &:hover {
      background: ${getColor(c => c.tokens.static["static-white"], theme)};
      border-color: ${getColor(c => c.foundations.blue[400], theme)};
      box-shadow:
        0px 0px 0px 2px ${getColor(c => c.tokens.static["static-white"], theme)},
        0px 0px 0px 4px
          ${getColor(c => c.foundations.alpha.neutral["alpha-16"], theme)};
    }
  `,
);

export const WorkerDescription = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    span {
      color: ${getColor(c => c.tokens.text["strong-950"], theme)};
    }

    span:last-of-type {
      color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    }
  `,
);
